import { LISTING_OVERVIEW_TAB_SEGMENT } from './useListingProfileEditBlockOpener.constants'

export function getIsNotListingOverviewTab(tab) {
  return tab !== LISTING_OVERVIEW_TAB_SEGMENT
}
